import type { Restroom } from "../types";
import { INTL_LOCALE, type Locale } from "../i18n/locale";

/** Vzdálenost dvou bodů v metrech (haversine). */
export function distanceMeters(
  a: { lat: number; lng: number },
  b: { lat: number; lng: number },
): number {
  const R = 6_371_000;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

function toRad(deg: number): number {
  return (deg * Math.PI) / 180;
}

/** Nejbližší WC k danému bodu, nebo null pro prázdný seznam. */
export function nearestRestroom(
  from: { lat: number; lng: number },
  restrooms: Restroom[],
): Restroom | null {
  let best: Restroom | null = null;
  let bestDist = Infinity;
  for (const r of restrooms) {
    const d = distanceMeters(from, r);
    if (d < bestDist) {
      bestDist = d;
      best = r;
    }
  }
  return best;
}

/**
 * Lidsky čitelná vzdálenost podle locale, např. "320 m" / "1,4 km" (cs) nebo
 * "1.4 km" (en). Desetinný oddělovač řeší `Intl` podle jazyka.
 */
export function formatDistance(m: number, locale: Locale): string {
  if (m < 1000) return `${Math.round(m)} m`;
  const km = new Intl.NumberFormat(INTL_LOCALE[locale], {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(m / 1000);
  return `${km} km`;
}
